/** What each scope lets a connected app do, in the words the consent screen and the app list use. */
export const SCOPE_LABELS = {
    "projects:read": "Read projects, deployments, logs, processes, domains, nginx sites and certificates, and status",
    "infra:read": "Read nginx site files, nginx and system logs, and Claude session transcripts (secrets masked)",
    "projects:write": "Change manifests, pause or resume deploys, create projects and working copies, and manage monitors",
    deploy: "Deploy, roll back, and apply env changes to running processes",
    "env:write": "Set environment variables (never read them back)",
    "infra:write": "Restart, start and stop PM2 processes, and — each time with your approval — write nginx sites, reload nginx, issue certificates and point DNS records at this server",
    "sessions:run": "Start Claude sessions on the server, with your approval for every instruction. A session can do anything you can do in a terminal there",
    "projects:admin": "Delete a project, each time with a fresh passkey"
};

/** What an approval of each tier means, said once where it is approved. */
export const TIER_NOTES = {
    write: "Approving lets this app's next changes through for five minutes.",
    infra: "Root on the server. Approved on its own — it never opens the five-minute window.",
    session: "An instruction to a Claude session that can do anything you can in a terminal. Read it in full before approving.",
    destroy: "Cannot be undone. Approved on its own."
};
